module.exports = __webpack_public_path__ + "static/flow1-5b3020c7c6aec3c61aac9990f3aaebdd.svg";